// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AfterpayCardPrepurchaseEntryPointTappedEvent
 *
 * @deprecated Deprecated in favor of PrepurchaseCard.Toggle.Tap event.
 */
export var AfterpayCardPrepurchaseEntryPointTapped = function (_a) {
    var calledToggleEndpoint = _a.calledToggleEndpoint;
    return ({
        name: "AfterpayCard Prepurchase EntryPointTapped",
        parameters: {
            cdf_entity: "AfterpayCard",
            cdf_action: "Prepurchase",
            called_toggle_endpoint: calledToggleEndpoint !== undefined && calledToggleEndpoint !== null ? calledToggleEndpoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayCardPrepurchaseEntryPointButtonTappedEvent
 *
 * @deprecated Deprecated in favor of PrepurchaseCard entity.
 */
export var AfterpayCardPrepurchaseEntryPointButtonTapped = function () { return ({
    name: "AfterpayCard Prepurchase EntryPointButtonTapped",
    parameters: {
        cdf_entity: "AfterpayCard",
        cdf_action: "Prepurchase",
    }
}); };
/**
 * @see AfterpayCardPrepurchaseHomeSheetViewedEvent
 *
 * @deprecated Deprecated in favor of PrepurchaseCard.HalfSheet.View event.
 */
export var AfterpayCardPrepurchaseHomeSheetViewed = function (_a) {
    var sheetType = _a.sheetType;
    return ({
        name: "AfterpayCard Prepurchase HomeSheetViewed",
        parameters: {
            cdf_entity: "AfterpayCard",
            cdf_action: "Prepurchase",
            sheet_type: sheetType !== undefined && sheetType !== null ? sheetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayCardPrepurchaseOptionsSheetViewedEvent
 *
 * @deprecated Deprecated in favor of PrepurchaseCard.HalfSheet.ViewSubpage event.
 */
export var AfterpayCardPrepurchaseOptionsSheetViewed = function () { return ({
    name: "AfterpayCard Prepurchase OptionsSheetViewed",
    parameters: {
        cdf_entity: "AfterpayCard",
        cdf_action: "Prepurchase",
    }
}); };
/**
 * @see AfterpayCardPrepurchaseHomeSheetButtonTappedEvent
 *
 * @deprecated Deprecated in favor of PrepurchaseCard entity.
 */
export var AfterpayCardPrepurchaseHomeSheetButtonTapped = function (_a) {
    var buttonType = _a.buttonType, selectedOptions = _a.selectedOptions;
    return ({
        name: "AfterpayCard Prepurchase HomeSheetButtonTapped",
        parameters: {
            cdf_entity: "AfterpayCard",
            cdf_action: "Prepurchase",
            button_type: buttonType !== undefined && buttonType !== null ? buttonType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_options: selectedOptions !== undefined && selectedOptions !== null ? selectedOptions.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayCardPrepurchaseHomeSheetRowTappedEvent
 *
 * @deprecated Deprecated in favor of PrepurchaseCard entity.
 */
export var AfterpayCardPrepurchaseHomeSheetRowTapped = function (_a) {
    var cellType = _a.cellType, selectedOptions = _a.selectedOptions;
    return ({
        name: "AfterpayCard Prepurchase HomeSheetRowTapped",
        parameters: {
            cdf_entity: "AfterpayCard",
            cdf_action: "Prepurchase",
            cell_type: cellType !== undefined && cellType !== null ? cellType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_options: selectedOptions !== undefined && selectedOptions !== null ? selectedOptions.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
